import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function SedanCabServiceMumbai() {



    const cardData = {





keyword: "Sedan Cab Service Mumbai",

headingDescription: "Shreesha Tours & Travels offers premium Sedan Cab Service in Mumbai for local travel, airport transfers, corporate transportation, railway station pickup and drop, business meetings, family vacations, sightseeing tours, one-way trips, round-trip journeys, and outstation travel across India. Our sedan fleet includes comfortable and well-maintained vehicles such as Swift Dzire, Honda Amaze, Hyundai Aura, and other premium sedan cars that provide smooth rides, spacious interiors, excellent luggage capacity, and fuel-efficient travel. Whether you are traveling alone, with family, or for corporate purposes, our chauffeur-driven sedan cabs ensure a safe, comfortable, and economical journey. With experienced drivers, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, Shreesha Tours & Travels delivers reliable transportation for every occasion. From short city rides to long-distance outstation tours, our Mumbai sedan cab service guarantees punctuality, comfort, and a hassle-free travel experience.",

topPlaces: [
  {
    title: "Mumbai to Matheran",
    description: "Matheran is a charming hill station known for its pollution-free environment, toy train, Panorama Point, Echo Point, and scenic viewpoints. Sedan cabs are a comfortable choice for couples and families visiting this peaceful destination."
  },
  {
    title: "Mumbai to Bhandardara",
    description: "Bhandardara is a beautiful lakeside hill destination famous for Arthur Lake, Randha Falls, Wilson Dam, and lush green landscapes. It is an excellent choice for nature lovers and weekend travelers."
  },
  {
    title: "Mumbai to Igatpuri",
    description: "Igatpuri is a popular hill station surrounded by the Sahyadri ranges, offering waterfalls, trekking spots, Vipassana International Academy, and pleasant weather throughout the year."
  },
  {
    title: "Mumbai to Tarkarli",
    description: "Tarkarli is one of Maharashtra's most beautiful beach destinations, famous for scuba diving, snorkeling, water sports, clean beaches, and Sindhudurg Fort. Sedan travel offers a comfortable journey for coastal vacations."
  },
  {
    title: "Mumbai to Dapoli",
    description: "Dapoli is a peaceful Konkan destination known for Ladghar Beach, Karde Beach, Murud Beach, dolphin watching, and beautiful coastal landscapes. It is ideal for family holidays and weekend road trips."
  },
  {
    title: "Mumbai to Harihareshwar",
    description: "Harihareshwar is famous for its ancient Shiva Temple, serene beaches, coastal cliffs, and peaceful surroundings. It is a preferred destination for pilgrims and beach lovers alike."
  },
  {
    title: "Mumbai to Saputara",
    description: "Saputara is Gujarat's only hill station, offering Sunset Point, Saputara Lake, ropeway rides, tribal museums, and cool weather. It is an ideal destination for family vacations and couples."
  },
  {
    title: "Mumbai to Daman",
    description: "Daman is a beautiful coastal destination known for Devka Beach, Jampore Beach, Portuguese forts, churches, and seaside resorts. It is one of the most popular weekend getaways from Mumbai."
  },
  {
    title: "Mumbai to Murud Janjira",
    description: "Murud Janjira is famous for its historic sea fort, clean beaches, coconut groves, and scenic coastline. Sedan cabs provide a relaxing journey for families and history enthusiasts."
  },
  {
    title: "Mumbai to Kaas Plateau",
    description: "Kaas Plateau, also known as the Valley of Flowers of Maharashtra, is a UNESCO World Natural Heritage Site famous for seasonal wildflowers, breathtaking landscapes, and nature photography. It is a wonderful destination for road trips during the monsoon season."
  }
],



"services": [
  {
    "name": "Sedan Cab Service Mumbai",
    "description": "Book Sedan Cab Service Mumbai for comfortable, affordable, and reliable chauffeur-driven travel with clean AC vehicles and professional drivers. Our sedan cabs are perfect for airport transfers, local city travel, business meetings, family outings, sightseeing tours, hotel transfers, and outstation journeys with convenient one way and round trip booking options."
  },
  {
    "name": "Mumbai Sedan Taxi Service",
    "description": "Choose Mumbai Sedan Taxi Service for smooth and hassle-free transportation with well-maintained sedan cars, experienced chauffeurs, and transparent pricing. Enjoy comfortable travel for corporate visits, airport pickup and drop, family travel, weekend trips, and long-distance outstation rides."
  },
  {
    "name": "Sedan Car Rental Mumbai",
    "description": "Hire Sedan Car Rental Mumbai for premium chauffeur-driven travel with spacious AC vehicles and flexible rental packages. Perfect for business executives, tourists, family vacations, weddings, airport transfers, and interstate travel with reliable customer support."
  },
  {
    "name": "Sedan Cab Booking Mumbai",
    "description": "Complete Sedan Cab Booking Mumbai online with instant confirmation, affordable fares, and multiple sedan vehicle options. Reserve your preferred cab for airport transfers, office travel, sightseeing, family functions, hotel pickup, and comfortable outstation journeys."
  },
  {
    "name": "Sedan Taxi Mumbai",
    "description": "Book Sedan Taxi Mumbai for safe and comfortable transportation with courteous drivers, clean interiors, and well-maintained vehicles. Suitable for local rides, airport transfers, business travel, personal trips, and long-distance journeys across Maharashtra and India."
  },
  {
    "name": "Sedan Car Hire Mumbai",
    "description": "Choose Sedan Car Hire Mumbai for reliable chauffeur-driven transportation with flexible travel schedules and affordable rental packages. Our sedan cars provide comfortable travel for corporate meetings, family outings, sightseeing tours, weddings, and airport pickup and drop services."
  },
  {
    "name": "Sedan Outstation Cab Mumbai",
    "description": "Reserve Sedan Outstation Cab Mumbai for smooth one way and round trip travel to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other cities. Enjoy spacious seating, experienced drivers, transparent pricing, and comfortable highway travel."
  },
  {
    "name": "Sedan Airport Taxi Mumbai",
    "description": "Book Sedan Airport Taxi Mumbai for timely airport pickup and drop with professional chauffeurs, flight monitoring, luggage assistance, and comfortable AC vehicles. Travel conveniently to and from Mumbai Airport with dependable transportation available 24x7."
  },
  {
    "name": "Sedan Car Rental with Driver Mumbai",
    "description": "Hire Sedan Car Rental with Driver Mumbai for stress-free travel with experienced chauffeurs, premium comfort, and flexible booking options. Ideal for business travel, family functions, hotel transfers, city tours, airport transfers, and outstation journeys."
  },
  {
    "name": "Swift Dzire Sedan Cab Mumbai",
    "description": "Book Swift Dzire Sedan Cab Mumbai for economical and comfortable travel with fuel-efficient AC vehicles, professional drivers, and spacious interiors. Perfect for airport transfers, office commutes, family travel, sightseeing, and one way or round trip outstation journeys."
  },
  {
    "name": "Sedan Corporate Cab Mumbai",
    "description": "Choose Sedan Corporate Cab Mumbai for executive transportation, employee travel, airport transfers, client meetings, conferences, and official business trips. Our professional chauffeurs ensure punctual, safe, and comfortable corporate travel experiences."
  },
  {
    "name": "Sedan One Way Cab Mumbai",
    "description": "Reserve Sedan One Way Cab Mumbai for affordable intercity travel without return fare charges. Enjoy fixed pricing, comfortable AC vehicles, experienced drivers, and convenient pickup services for business trips, airport transfers, and long-distance travel."
  },
  {
    "name": "Sedan Round Trip Taxi Mumbai",
    "description": "Book Sedan Round Trip Taxi Mumbai for convenient return journeys with flexible travel schedules, affordable packages, and reliable chauffeur service. Ideal for family vacations, corporate visits, sightseeing tours, pilgrimage trips, and weekend getaways."
  },
  {
    "name": "Affordable Sedan Cab Mumbai",
    "description": "Choose Affordable Sedan Cab Mumbai for budget-friendly transportation with quality vehicles, professional chauffeurs, and transparent pricing. Travel comfortably for airport transfers, local rides, office travel, family outings, and outstation journeys without compromising safety or comfort."
  },
  {
    "name": "Best Sedan Cab Service Mumbai",
    "description": "Book the Best Sedan Cab Service Mumbai for premium chauffeur-driven travel with clean AC vehicles, experienced drivers, competitive fares, and exceptional customer support. Whether you need airport transfers, corporate transportation, family trips, sightseeing tours, wedding travel, or outstation journeys, our sedan cab service ensures a smooth, safe, and comfortable travel experience every time."
  }
],
"tableData": [
  ["Sedan Cab Service Mumbai", "Mumbai Sedan Taxi Service"],
  ["Sedan Car Rental Mumbai", "Sedan Cab Booking Mumbai"],
  ["Sedan Taxi Mumbai", "Sedan Car Hire Mumbai"],
  ["Sedan Outstation Cab Mumbai", "Sedan Airport Taxi Mumbai"],
  ["Sedan Car Rental with Driver Mumbai", "Swift Dzire Sedan Cab Mumbai"],
  ["Sedan Corporate Cab Mumbai", "Sedan One Way Cab Mumbai"],
  ["Sedan Round Trip Taxi Mumbai", "Affordable Sedan Cab Mumbai"],
  ["Best Sedan Cab Service Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Premium Sedan Cab Service in Mumbai",
    WhyChoosedescription: "Travel in comfort and style with Shreesha Travels' Sedan Cab Service in Mumbai. Our chauffeur-driven sedan cars are ideal for airport transfers, business meetings, city travel, family outings, hotel transfers, and long-distance journeys, offering a smooth and relaxing travel experience."
  },
  {
    WhyChooseheading: "Comfort Meets Convenience on Every Ride",
    WhyChoosedescription: "Sedan cars provide spacious interiors, comfortable seating, excellent ride quality, and generous luggage space, making them a preferred choice for both daily travel and extended road trips."
  },
  {
    WhyChooseheading: "Perfect for Local & Outstation Destinations",
    WhyChoosedescription: "Book a sedan cab from Mumbai to Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Surat, Ahmedabad, Indore, Jaipur, Bengaluru, and numerous destinations across India."
  },
  {
    WhyChooseheading: "Suitable for Business Executives & Leisure Travellers",
    WhyChoosedescription: "Our sedan taxis are widely chosen for corporate travel, client meetings, conferences, airport transfers, sightseeing, family vacations, medical appointments, and weekend getaways."
  },
  {
    WhyChooseheading: "Flexible Taxi Booking Options",
    WhyChoosedescription: "Select one-way transfers, round trips, airport pickups, full-day rentals, multi-day travel, or personalized travel packages designed around your itinerary."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Comfortable Travel",
    WhyChoosedescription: "Our courteous and experienced drivers ensure punctual pickups, safe driving, efficient route planning, and a pleasant travel experience throughout your journey."
  },
  {
    WhyChooseheading: "Well-Maintained Sedan Fleet",
    WhyChoosedescription: "Every sedan is regularly serviced, sanitized, air-conditioned, and carefully inspected to deliver dependable performance, safety, and comfort on every trip."
  },
  {
    WhyChooseheading: "Choose Shreesha Travels for Sedan Cab Booking",
    WhyChoosedescription: "Benefit from transparent pricing, responsive customer support, easy reservations, and reliable chauffeur-driven sedan services for every travel requirement in and around Mumbai."
  }
]

};

const faqData = [
  {
    question: "Which sedan cars are available for booking in Mumbai?",
    answer: "Our sedan fleet includes popular models such as Swift Dzire and other comfortable sedan vehicles suitable for local, airport, and outstation travel."
  },
  {
    question: "Who should choose a sedan cab service?",
    answer: "Sedan cabs are ideal for business executives, couples, small families, tourists, airport travellers, and anyone seeking a comfortable and affordable travel option."
  },
  {
    question: "Can I hire a sedan cab for outstation trips?",
    answer: "Yes, sedan cabs are available for one-way journeys, round trips, weekend holidays, and long-distance travel to destinations across India."
  },
  {
    question: "Are sedan taxis available for Mumbai Airport transfers?",
    answer: "Yes, we provide chauffeur-driven sedan cabs for airport pickups and drop-offs at both domestic and international terminals."
  },
  {
    question: "Can I book a sedan for corporate meetings?",
    answer: "Yes, sedan taxis are frequently reserved for executive travel, office meetings, client visits, conferences, and business events."
  },
  {
    question: "Do you provide full-day sedan rental packages?",
    answer: "Yes, hourly, full-day, and customized rental packages are available depending on your travel schedule."
  },
  {
    question: "Is advance booking recommended for sedan cabs?",
    answer: "Yes, advance reservations help ensure your preferred vehicle is available, particularly during weekends, holidays, and peak travel seasons."
  },
  {
    question: "Can I include multiple destinations in a single booking?",
    answer: "Yes, customized travel plans with multiple pickup or drop locations can be arranged according to your itinerary."
  },
  {
    question: "How is the sedan cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, destination, and selected travel package."
  },
  {
    question: "How can I book a Sedan Cab Service in Mumbai with Shreesha Travels?",
    answer: "Simply provide your pickup point, destination, travel date, passenger details, and preferred schedule to receive a personalized quotation and quick booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Kulshreshtha",
    feedback: "The sedan offered a quiet, comfortable ride that made the entire journey enjoyable. Timely service, courteous assistance, and excellent vehicle condition reflected a high standard of professionalism.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Choksi",
    feedback: "Every detail was handled with care, from the reservation process to the final destination. The smooth drive and comfortable seating made the trip relaxing and completely hassle-free.",
    rating: 5
  }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/sedan-cab-service-mumbai.webp",
  "description":
    "Book Sedan Cab Service Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable chauffeur-driven sedan taxi services. We provide Swift Dzire and other sedan cars available 24x7 for airport transfers, local travel, corporate meetings, business trips, family journeys, and outstation travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/sedan-cab-service-mumbai"
  }
};




    return (
        <div>

<Helmet>
  <title>Sedan Cab Service Mumbai | Affordable Sedan Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Sedan Cab Service Mumbai with Shreesha Travels for reliable sedan taxi rental services. Hire Swift Dzire and other sedan cars with driver for airport transfers, local rides, corporate travel, and outstation trips with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Sedan Cab Service Mumbai, Mumbai Sedan Taxi Service, Sedan Car Rental Mumbai, Sedan Cab Booking Mumbai, Sedan Taxi Mumbai, Sedan Car Hire Mumbai, Sedan Outstation Cab Mumbai, Sedan Airport Taxi Mumbai, Sedan Car Rental with Driver Mumbai, Swift Dzire Cab Mumbai, Sedan One Way Cab Mumbai, Sedan Round Trip Taxi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default SedanCabServiceMumbai;